import styled from "@emotion/styled"

export const BlocksSidebarStyles = styled.div`
    background-color: #f8f8f8;
    box-shadow: 0 0 9px -2px rgba(0, 0, 0, 0.23);
    display: grid;
    grid-template-rows: auto 60px;
    grid-template-columns: 100%;
`